import http from '@/utils/http';
const baseUrl = '/protocolos-analise';

export default {
    buscarProtocolos() {
        return http.get({
            url: baseUrl,
            lockScreen: false
        });
    }
};
